import { Role, IUser } from "@/shared/types"

export const getUserRole = (user: IUser): Role => user.authorities?.[0]?.authority || Role.CustomerAdmin
